import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./cancel-application-confirmation.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./cancel-application-confirmation.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Inject, Input } from "@angular/core";
import { APP_BASE_HREF } from "@angular/common";
import { RejectAuthoriseConstants, VALIDATION_MESSAGE } from "./cancel-application-confirmation.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "src/app/shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AppConfig } from "src/app/app.config";
let CancelApplicationConfirmationComponent = class CancelApplicationConfirmationComponent {
    baseHref;
    modalService;
    title;
    description;
    authorise;
    rejectAuthoriseForm;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    rejectAuthoriseValidation = VALIDATION_MESSAGE;
    rejectAuthoriseFormControl = RejectAuthoriseConstants.REJECT_AUTHORISE_FORM_CONTROL;
    rejectAuthoriseLabel = RejectAuthoriseConstants.REJECT_AUTHORISE_LABEL;
    titleLabel = RejectAuthoriseConstants.TITLE_LABEL;
    cancelBtnLabel = SharedConstants.CANCEL_LABEL;
    continueBtnLabel = RejectAuthoriseConstants.CONTINUE_BTN_LABEL;
    constructor(baseHref, modalService) {
        this.baseHref = baseHref;
        this.modalService = modalService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnChanges(changes) {
    }
    ngOnInit() {
        this.initForm();
    }
    initForm() {
        this.rejectAuthoriseForm = new FormGroup({
            rejectAuthorise: new FormControl(null, Validators.required)
        });
    }
    onBtnCancelClicked() {
        this.modalService.close();
    }
    onBtnContinueClicked() {
        this.modalService.close(true);
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        description: [{ type: Input }],
        authorise: [{ type: Input }]
    };
};
CancelApplicationConfirmationComponent = __decorate([
    Component({
        selector: "app-cancel-application-confirmation",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CancelApplicationConfirmationComponent);
export { CancelApplicationConfirmationComponent };
